<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item" @click.prevent="mtdgotoprincipal()" style="cursor: pointer;">PRINCIPAL</li>                
                <li v-if="!bcitens.item1.ativo" class="breadcrumb-item active" >{{bcitens.item1.titulo}} <i :class="fav == 1 ? 'fa fa-star ' : 'fa fa-star-o '" :style="fav == 1 ? 'color: gold; margin-left: 5px; cursor: pointer;' : 'margin-left: 5px; cursor: pointer;'" title="Adicionar aos favoritos" @click.prevent="mtdaddfav()"></i></li>
                <li v-else class="breadcrumb-item"><a href="#" @click.prevent="mtdcancelar()">{{bcitens.item1.titulo}}</a></li>
                <li v-if="bcitens.item2.ativo" class="breadcrumb-item active">{{bcitens.item2.titulo}}</li>
            </ol>
        </nav>        
    </div>
</template>
<script>
import util from '../utilitarios/util.js'
export default {
    name: 'cmpbreadcrumb',
    props:['bcitens',
           'mtdcancelar'
          ],
    data: function() {
        return {
            fav : 0,
        };
        
    },
    methods: {
        mtdgotoprincipal() {
            util.gotoprincipal();
        },
        mtdaddfav(){
        let loader = this.$loading.show();
           util.adicionafav(this, this.$router.history.current.path)
            .then((response) => {
                this.fav = response.data.op;
                if(response.data.op == 1){
                    this.$toastr.s('Adicionado aos favoritos com sucesso!', 'Informação!');
                }else if(response.data.op == 0){
                    this.$toastr.s('Removido de favoritos com sucesso!', 'Informação!');
                }
                loader.hide();
            })
            .catch((erro) => {
                console.log("Erro ao adicionar favorito:", erro);
            });
        },
        consultafav(){
            var vself       = this;
            let loader      = this.$loading.show();
            let parametros  = [
                {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           valor : 'verificafav'},
                {parametro: 'routerfav',    valor : this.$router.history.current.path},
                {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
            retorno.then(function (response) {
                vself.mtdigualacampos(response.data);        
                loader.hide();
            }).catch(function (response) {
                loader.hide();
            });
        },
        mtdigualacampos(registro){
            this.fav = registro.op;
        }       
    },
    computed:{

    },
    watch: {

    },
    mounted: function (){
        this.consultafav();
    }
}
</script>